import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetWorkflowStatusParams extends PaginationProps {}

interface CreateWorkflowStatus {
  name: string;
}

interface UpdateWorkflowStatus extends CreateWorkflowStatus {
  id: number | null;
}

export async function getWorkflowStatuses() {
  const { data } = await api.get('/workflow-statuses');
  return data;
}

export async function getWorkflowStatusesMasterData(
  params: GetWorkflowStatusParams
) {
  const { data } = await api.get('/workflow-statuses/master-data', {
    params
  });
  return data;
}

export async function getWorkflowStatus(id: number) {
  const { data } = await api.get(`/workflow-statuses/${id}`);
  return data;
}

export async function createWorkflowStatus(
  createWorkflowStatus: CreateWorkflowStatus
) {
  const { data } = await api.post('/workflow-statuses', createWorkflowStatus);
  return data;
}

export async function updateWorkflowStatus(
  updateWorkflowStatus: UpdateWorkflowStatus
) {
  const { data } = await api.put(
    `/workflow-statuses/${updateWorkflowStatus.id}`,
    updateWorkflowStatus
  );
  return data;
}

export function deleteWorkflowStatus(id: number) {
  return api.delete(`/workflow-statuses/${id}`);
}
